const terms = {
  caraKerja: {
    label: "Cara Kerja Afiliasi",
    data: [
      {
        name: "Bagikan link referral anda kepada teman anda dan ajak mereka untuk mendaftar SmartOwner.",
      },
      {
        name:
          "Tidak ada perbedaan saat proses registrasi. Hanya, nama anda akan tercantum sebagai afiliator apabila seseorang mendaftar dengan link referall anda.",
      },
      {
        name:
          "Apabila proses registrasi berhasil, “Teman Afiliasi”mu akan bertambah. Teman Afiliasi dibedakan menjadi 2 yaitu Register dan Aktivasi.",
      },
      {
        name:
          "Setiap teman afiliasi yang melakukan aktivasi outlet, kamu akan diberikan komisi sebesar 30% yang akan masuk ke Saldo Dompet afiliasi anda. Baca selanjutnya di bagian Saldo Dompet.",
      },
      {
        name:
          "Teman Afiliasi tidak dapat dipindahkan atau diakuisisi secara manual.  Seseorang dapat menjadi Teman Afiliasi anda hanya dengan cara pendaftaran melalui link referral dan otomatis via sistem.",
      },
    ],
  },
  saldoDompet: {
    label: "Saldo Dompet",
    data: [
      {
        name:
          "Saldo Dompet afiliasi yang didapatkan adalah 30% dari biaya aktivasi outlet untuk setiap teman afiliasi yang menggunakan link referall anda",
      },
      {
        name:
          "Jika teman afiliasi mengaktivasi menggunakan promo ataupun diskon, maka persentase fee dihitung setelah diskon.",
      },
      {
        name:
          "Saldo Dompet hanya didapatkan dari aktivasi outlet. Jika teman afiliator melakukan top-up paylink, top-up m-coin, upgrade power merchant dan lain-lain, anda tidak mendapatkan apa-apa",
      },
      {
        name: "Saldo Dompet dapat dicairkan dengan cara tarik tunai pada setiap tanggal 1-4 di awal bulan.",
      },
      {
        name: "Permintaan tarik tunai akan diproses (ditranser) pada tanggal 5-7 bulan tersebut.",
      },
      {
        name:
          "Pencairan dapat gagal apabila terdapat kesalahan data pada rekening pencairan. Pencairan dapat dilakukan kembali bulan depan.",
      },
    ],
  },
};

export default terms;
